import firebase from 'fb/initconfig';
import { Action } from 'redux';
import { SubscriberRecord } from 'types';

export type FBChanges = firebase.firestore.DocumentChange<firebase.firestore.DocumentData>[];

export const UPDATE_SUBSCRIBER = '@@mjbj/UPDATE_SUBSCRIBER';
export type UPDATE_SUBSCRIBER = typeof UPDATE_SUBSCRIBER;

export interface UpdateSubscriber extends Action {
	type: UPDATE_SUBSCRIBER;
	changes: FBChanges;
}

export function updateSubscriber(changes: FBChanges): UpdateSubscriber {
	return {
		type: UPDATE_SUBSCRIBER,
		changes,
	};
}

export const UPDATE_SUBSCRIBER_FILTERED = UPDATE_SUBSCRIBER + '_FILTERED';
export type UPDATE_SUBSCRIBER_FILTERED = typeof UPDATE_SUBSCRIBER_FILTERED;

export interface UpdateSubscriberFiltered extends Action {
	type: UPDATE_SUBSCRIBER_FILTERED;
	payload: SubscriberRecord[];
}
